import styled from 'styled-components';

export const ResourceContentDescription = styled.div`
  & p,
  & span {
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
    color: var(--color-text);
    white-space: pre-line;
  }

  & em {
    font-style: italic;
  }

  & strong {
    font-weight: 700;
  }

  & s,
  & del {
    text-decoration: line-through;
  }

  & .read-more {
    font-weight: 700;
    white-space: break-spaces;

    display: inline-block;

    color: var(--color-primary);

    cursor: pointer;
  }
`;
